import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LOGO_IMG, LOGO_IMG_WHITE } from "@/mocks/lawfirm";

const navLinks = [
  { label: "변호사 소개", to: "/#about" },
  { label: "수행사건", to: "/#practice" },
  { label: "언론보도", to: "/#press" },
  { label: "승소사례", to: "/#cases" },
  { label: "회생파산센터", to: "/#center" },
  { label: "형사사건", to: "/criminal" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const handleAnchor = (
    e: React.MouseEvent<HTMLAnchorElement>,
    to: string
  ) => {
    if (!to.startsWith("/#")) return;
    e.preventDefault();
    const hash = to.split("#")[1];
    if (location.pathname !== "/") {
      window.REACT_APP_NAVIGATE("/");
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const solid = scrolled;
  const textCls = solid
    ? "text-foreground-900"
    : "text-white";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-white shadow-[0_1px_0_0_rgba(0,0,0,0.06)]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img
            src={solid ? LOGO_IMG : LOGO_IMG_WHITE}
            alt="법무법인 평율 로고"
            title="법무법인 평율"
            className="h-10 md:h-11 w-auto object-contain"
          />
        </Link>

        <div className="hidden md:flex items-center gap-7 lg:gap-9">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.to}
              onClick={(e) => handleAnchor(e, l.to)}
              className={`text-sm font-medium tracking-tight hover:text-accent-600 transition-colors whitespace-nowrap ${textCls}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://m.booking.naver.com/booking/6/bizes/1503484/items/7082029?area=pll&lang=ko&startDate=2026-09-21&theme=place"
            target="_blank"
            rel="noopener noreferrer"
            className={`hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-accent-600 transition-colors ${
              solid ? "text-foreground-950" : "text-foreground-950"
            }`}
          >
            <i className="ri-calendar-check-line text-base"></i>
            네이버 상담 예약
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="메뉴"
            className={`md:hidden flex items-center justify-center w-10 h-10 rounded-md ${textCls}`}
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-t border-background-200">
          <div className="flex flex-col px-4 py-3 gap-1">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.to}
                onClick={(e) => handleAnchor(e, l.to)}
                className="flex items-center justify-between px-3 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400"></i>
              </a>
            ))}
            <a
              href="https://m.booking.naver.com/booking/6/bizes/1503484/items/7082029?area=pll&lang=ko&startDate=2026-09-21&theme=place"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-white"
            >
              <i className="ri-calendar-check-line text-base"></i>
              네이버 상담 예약
            </a>
          </div>
        </div>
      )}
    </header>
  );
}